import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconChanges: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconChanges"><Path fillRule="evenodd" clipRule="evenodd" d="M21 21H3V3H21V21ZM8.5 15.25V16.75H15.5V15.25H8.5ZM11.25 9.75H8.5V11.25H11.25V14H12.75V11.25H15.5V9.75H12.75V7H11.25V9.75Z" fill="currentColor"/></CentralIconBase>;
});

export default IconChanges;
